import { TYPES } from "../Constants/history";

export const formatType = (value) => {
  if (value === TYPES.PAY) return "PAY";
  else if (value === TYPES.DISTRIBUTION) return "DISTRIBUTION";
  else if (value === TYPES.NOCOUNT) return "NO COUNT";
  else if (value === TYPES.BUYBACK) return "BUY BACK";
};

export const formatDate = (value) => {
  const time = new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
  const day = new Intl.DateTimeFormat("vi-VN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(value));
  return `${day}, ${time}`;
};

export const formatNumber = (number) => {
  return number.toLocaleString("vi-VN");
};

export const formatDay = (value) => {
  const day = new Intl.DateTimeFormat("vi-VN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(value));
  return `${day}`;
};

const createLocalDate = (year, month, day) => {
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  return date;
};

export const parseProfileDateValue = (value) => {
  if (!value) return null;
  if (value instanceof Date && !Number.isNaN(value.getTime())) return value;

  if (typeof value === "string") {
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [year, month, day] = value.split("-").map(Number);
      return createLocalDate(year, month, day);
    }

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
      const [day, month, year] = value.split("/").map(Number);
      return createLocalDate(year, month, day);
    }

    const normalized = value
      .replace(/\s+/g, " ")
      .trim()
      .replace(/(\d:\d{2})(AM|PM)/i, "$1 $2");

    const date = new Date(normalized);
    if (!Number.isNaN(date.getTime())) return date;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDateToDdMmYyyy = (value) => {
  const date = parseProfileDateValue(value);
  if (!date) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}/${date.getFullYear()}`;
};

export const formatDateToIso = (value) => {
  const date = parseProfileDateValue(value);
  if (!date) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};

export const formatProfileDay = (value) => {
  const date = parseProfileDateValue(value);
  if (!date) return "";
  return formatDay(date);
};
